export const REDUX_SET = '/redux/container/TakeRentMoney/set';
export const REDUX_RESET = '/redux/container/TakeRentMoney/reset';
